<template>
  <div class="content">
    <div :class="{bg: true, empty: resources && resources.length === 0}">
      <div class="filterline">
        <div class="date">
          <span class="sub">
            外出日期
          </span>
          <date-picker range :disabled="disableCalendar" v-model="datePicker" placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
        </div>
        <div class="btns un">
          <p class="btn" @click="refresh()">
            <img src="@assets/img/resources/fresh.svg" alt="fresh">
            <span>刷新</span>
          </p>
          <p v-if="has_download" class="btn greenBtn" @click="exportRes()">
            <img src="@assets/img/resources/export.svg" alt="fresh">
            <span>导出</span>
          </p>
        </div>
      </div>
      <div class="status" v-for="(f, d) in filters" :key="d">
        <span class="sub">{{f.title}}</span>
        <p :class="{btn: true, selected: s.selected}" v-for="(s, si) in f.list" :key="si" @click="switchStatus(s, f)">
          {{s.title}}
        </p>
      </div>
      <div class="titleline">
        <span class="title">采访事件</span>
        <span class="remarktxt">备注</span>
        <span class="reporters">记者</span>
        <span class="time">开始／结束时间</span>
        <span class="driver">司机</span>
        <span class="camera">摄像</span>
        <span class="bus">采访车</span>
        <span class="handles">操作</span>
      </div>
      <empty :mTop="50" :msg="'暂无资源数据'" v-if="resources && resources.length === 0" />
      <div class="items" v-for="(resource, resourceIndex) in resources" :key="resourceIndex+1">
        <div class="item">
          <div class="title">
            <div class="titleName">
              <p class="words" @click="goItv(resource.id)" :title="resource.title">
                {{resource.title}}
              </p>
              <!-- <span class="msg" v-if="resource.remark">
                <img class="msg" src="@assets/img/index/remark.svg" alt="remark">
                <p class="remark">
                  {{resource.remark}}
                </p>
              </span> -->
            </div>
            <p class="words locate">
              {{resource.address}}
            </p>
          </div>
          <div class="remarktxt">
            <span @click="canShowTxt(resource,resourceIndex)" :title="resource.remark" v-show="!resource.showTxt">{{resource.remark || '无'}}</span>
            <textarea :ref="'txt'+resourceIndex" v-show="resource.showTxt" v-model="resource.remark" placeholder="无" maxlength="200" @focus="remarkFocus(resource)" @blur="remarkBlur(resource)"></textarea>
            <div class="confirm" v-if="resource.showRmkConfirm && resource.showTxt">
              <img @mousedown="confirmRmk(resource)" src="@assets/img/login/checker.svg" alt="checker">
            </div>
          </div>
          <div class="reporters">
            <img src="@assets/img/index/reporter.svg" alt="reporter">
            <p style="display: flex;flex-direction: row">
              <span v-show="i < 2" v-for="(r, i) in resource.reporters" :key="i" @click="showCard(r.id, $event)">
                {{`${r.name}${i===resource.reporters.length-1?'': i == 1 ? '' : ','}`}}
              </span>
              <i v-if="resource.reporters.length > 2">...</i>
            </p>
          </div>
          <div class="time">
            <div class="times">
              <p>
                <input v-if="resource.status == 1" type="text" v-model="resource.start" @focus="timeFocus(resource)" @blur="timeBlur(resource)">
                <span v-else>{{resource.start}}</span>
              </p>
              <p>
                <input v-if="resource.status == 1" type="text" v-model="resource.end" @focus="timeFocus(resource)" @blur="timeBlur(resource)">
                <span v-else>{{resource.end}}</span>
              </p>
            </div>
            <div class="confirm" v-if="resource.showConfirm">
              <img @mousedown="confirmTime(resource)" src="@assets/img/login/checker.svg" alt="checker">
            </div>
          </div>
          <div class="assign">
            <div class="todo" v-if="resource.drivers.list.length === 0 && !disableCalendar">
              <div class="driver" @click="openHandle(resource, resource.drivers.rc_id, resource.drivers.rc_name, resource.drivers.list)">
                <img :src="icons.driver" alt="司机">
                <span class="count">
                  {{resource.drivers.num}}
                </span>
              </div>
            </div>
            <div class="done placer" v-if="resource.drivers.list.length === 0 && resource.status != 1"></div>
            <div class="done" v-if="resource.drivers.list.length > 0">
              <div :class="{driver: true, notMatch: resource.drivers.list.length !== resource.drivers.num - 0}">
                <p :class="{'busy': d.status == 2}" v-for="(d, di) in resource.drivers.list" :key="di" @click="openHandle(resource, resource.drivers.rc_id, resource.drivers.rc_name, resource.drivers.list)">
                  {{d.name}}
                </p>
              </div>
            </div>
            <div class="todo" v-if="resource.cameras.list.length === 0  && !disableCalendar">
              <div class="camera" @click="openHandle(resource, resource.cameras.rc_id, resource.cameras.rc_name, resource.cameras.list)">
                <img :src="icons.camera" alt="摄像">
                <span class="count">
                  {{resource.cameras.num}}
                </span>
              </div>
            </div>
            <div class="done placer" v-if="resource.cameras.list.length === 0 && resource.status != 1"></div>
            <div class="done" v-if="resource.cameras.list.length > 0">
              <div :class="{camera: true, notMatch: resource.cameras.list.length !== resource.cameras.num - 0}">
                <p :class="{'busy': v.status == 2}" v-for="(v, vi) in resource.cameras.list" :key="vi" @click="openHandle(resource, resource.cameras.rc_id, resource.cameras.rc_name, resource.cameras.list)">
                  {{v.name}}
                </p>
              </div>
            </div>
            <div class="todo" v-if="resource.cars.list.length === 0  && !disableCalendar">
              <div class="bus" @click="openHandle(resource, resource.cars.rc_id, resource.cars.rc_name, resource.cars.list)">
                <img :src="icons.bus" alt="采访车">
                <span class="count">
                  {{resource.cars.num}}
                </span>
              </div>
            </div>
            <div class="done placer" v-if="resource.cars.list.length === 0 && resource.status != 1"></div>
            <div class="done" v-if="resource.cars.list.length > 0">
              <div :class="{bus: true, notMatch: resource.cars.list.length !== resource.cars.num - 0}">
                <p v-for="(c, ci) in resource.cars.list" :key="ci" @click="openHandle(resource, resource.cars.rc_id, resource.cars.rc_name, resource.cars.list)">
                  {{c.name}}
                </p>
              </div>
            </div>
          </div>
          <div :class="{handles: true, greenBtn: true, hide: disableCalendar}" @click="handleResource(resource, 1)">
            完成
          </div>
          <div :class="{handles: true, hide: disableCalendar}" @click="handleResource(resource, 2)">
            退回
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
      <resourceHandles ref="resourceHandles" />
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'
import DatePicker from 'vue2-datepicker'
import resourceHandles from '@components/resourceHandles'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'resources',
  components: {
    pages, DatePicker, resourceHandles, empty
  },
  data() {
    return {
      has_download: false,
      page: {
        page_count: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      resources: null,
      datePicker: [],
      icons: {
        driver: require('@assets/img/index/driver.svg'),
        bus: require('@assets/img/index/bus.svg'),
        camera: require('@assets/img/index/camera.svg')
      },
      filters: [],
      selectedStatus: {},
      searchOptions: {},
      filterOptions: {},
      disableCalendar: false
    }
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n, o) {
        this.page.pageIndex = 1
        this.filterOptions['start'] = this.getDayStart(n[0])
        this.filterOptions['end'] = this.getDayEnd(n[1])
        this.getList()
      }
    },
    filterOptions: {
      handler(n, o) {
        const status = n['status'] || ''
        if (status == 2) {
          this.disableCalendar = true
        } else {
          this.disableCalendar = false
        }
      },
      deep: true
    }
  },
  methods: {
    canShowTxt(resource,resourceIndex) {
      if(resource.status == 1){
        resource.showTxt = true
        console.log(this.$refs['txt'+resourceIndex][0])
        this.$nextTick(() => {
          this.$refs['txt'+resourceIndex][0].focus()
        })
      }
    },
    showCard(id, e) {
      if (id == 0) return

      const el = e.target

      this.$card(id, el)
    },
    remarkFocus(rsc) {
      this.$nextTick(() => {
        this.$set(rsc, 'showRmkConfirm', true)
      })
    },
    remarkBlur(rsc) {
      this.$set(rsc, 'showRmkConfirm', false)
      this.$set(rsc, 'showTxt', false)
    },
    timeFocus(rsc) {
      this.$nextTick(() => {
        this.$set(rsc, 'showConfirm', true)
      })
    },
    timeBlur(rsc) {
      this.$set(rsc, 'showConfirm', false)
      // this.getList()
    },
    confirmRmk(rsc) {
      // 确认提交备注
      const info = {
        iview_id: rsc.id,
        remark: rsc.remark
      }

      common.myFetch(apis.Res_modify_remark, info)
      .then((r) => {
        if (r) {
          this.$toast(r)
          this.$set(rsc, 'showRmkConfirm', false)
        }
        this.getList()
      })
    },
    confirmTime(rsc) {
      // 确认修改时间
      const info = {
        start: `${rsc.start}:00`,
        end: `${rsc.end}:00`,
        iview_id: rsc.id
      }

      common.myFetch(apis.Res_modify_time, info)
      .then((r) => {
        if (r) {
          this.$toast(r)
          this.$set(rsc, 'showConfirm', false)
        }
        this.getList()
      })
    },
    initTomorrow() {
      const tomorrow = this.getTomorrow()

      this.datePicker = tomorrow
    },
    getDayEnd(s) {
      // 获取当天的结束时间
      if (!s) {
        return ''
      }

      const year = s.getFullYear()
      const month = common.doubleDigit(s.getMonth() + 1)
      const day = common.doubleDigit(s.getDate())

      return  `${year}-${month}-${day} 23:59:59`
    },
    getDayStart(s) {
      // 获取当天的开始时间
      if (!s) {
        return ''
      }

      const year = s.getFullYear()
      const month = common.doubleDigit(s.getMonth() + 1)
      const day = common.doubleDigit(s.getDate())

      return  `${year}-${month}-${day} 00:00:00`
    },
    getTomorrow() {
      // 获取明天时间戳
      const today = +new Date()
      const tomarrow = new Date(today+1000*60*60*24)
      const year = tomarrow.getFullYear()
      const month = tomarrow.getMonth() + 1
      const day = tomarrow.getDate()
      const startSec = new Date(`${year}-${month}-${day} 00:00:00`)
      const endSec = new Date(`${year}-${month}-${day} 23:59:59`)

      return [startSec, endSec]
    },
    goItv(i) {
      // 跳转采访详情
      // this.$router.push({
      //   path: '/interviewDetail',
      //   query: {
      //     r: i
      //   }
      // })

      common.jump(`/interviewDetail?r=${i}`, true)
    },
    getList(keyWord) {
      //  获取列表数据
      const id = this.$route.params.id
      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions)

      common.myFetch(apis.Res_resource_list, info)
      .then((data) => {
        data.list.forEach(el => {
          el.showTxt = false;
        })
        this.has_download = data.has_download;
        this.resources = data.list
        this.generateFilters(data.params.list_search)
        this.generateSearchs(data.params.top_search.option.list)
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', data.page.row_count - 0)
      })
    },
    generateFilters(data) {
      // 整理过滤项数据
      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end'
      })

      this.filters = filters
    },
    generateSearchs(data) {
      // 整理搜索框数据并传递
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }

      this.postSearch(filterData)
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      // 发送过滤器数据
      this.$emit('filterData', data)
    },
    switchStatus(s, l) {
      // 切换过滤器选项
      if (s.selected) return

      this.page.pageIndex = 1

      l.list.forEach((i) => {
        this.$set(i, 'selected', false)
      })

      this.$set(s, 'selected', true)
      this.$nextTick(() => {
        // this.filterOptions[l.key] = s.key
        this.$set(this.filterOptions, l.key, s.key)
        this.getList()
      })
    },
    openHandle(res, id, name, list) {
      if (res.status != 1) return
      // 打开资源分配窗口
      const info = {
        title: res.title,
        interviewId: res.id,
        typeId: id,
        type: name,
        list: list,
        origin: res
      }

      this.$refs.resourceHandles.open(info)
      .then(r => {
        if (r) {
          this.getList()
        }
      })
    },
    async handleResource(r, s) {
      // 分配／退回 操作
      let msg = ''
      const notMatch = r.cameras.list.length !== r.cameras.num - 0 || r.cars.list.length !== r.cars.num - 0 || r.drivers.list.length !== r.drivers.num - 0

      if (s === 1) {
        if (notMatch) {
          msg = '已选资源与所需求的不匹配，确认完成吗？'
        } else {
          msg = '确认完成吗？'
        }
      } else {
        msg = '确认退回吗？'
      }

      const c = await this.$confirm(msg)
      if (!c) return

      const info = {
        iview_id: r.id,
        is_finish: s // 1:完成 2:退回
      }

      common.myFetch(apis.Res_resource_handle, info)
      .then((data) => {
        this.$toast(data)
        this.getList()
      })
    },
    refresh() {
      // 刷新
      // window.location.reload()
      this.getList()
    },
    exportRes() {
      // 导出
      const info = {
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        page_type: 'download'
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys, this.searchOptions, this.filterOptions)
      const url = apis.Res_resource_list
      // const url = apis.Res_resource_list + common.obj2Str(params)
      //
      // window.open(url)
      common.exportRes(url, params)
    }
  },
  mounted() {
    // this.getList()
    this.initTomorrow()
  }
}
</script>

<style lang="less" src="@assets/css/resource/resources.less" scoped></style>
